module.exports = __webpack_public_path__ + "static/media/Admin-14.6a006880.png";